import { useRef, useState } from 'react';
import AddClientFiles from './AddClientFiles';
import ClientFilesTableView from './ClientFilesTableView';
import { Box } from '@mui/system';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import { REFERRAL_STATUS_KEY } from '../../services/Constant';

const ClientFilesPage = () => {
  const [reload, setReload] = useState<boolean>(true);
  const parentRef = useRef<HTMLDivElement>(null);
  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const hasEditPermission =
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
        permissions['backend.in_active_referrals'].canEdit
      : permissions['backend.clients'].canEdit ||
        permissions['backend.in_active_referrals'].canEdit;

  return (
    <>
      <Box ref={parentRef}>
        <AddClientFiles
          updateReload={setReload}
          hasEditPermission={hasEditPermission}
        />
      </Box>
      <ClientFilesTableView
        reload={reload}
        hasEditPermission={hasEditPermission}
      />
    </>
  );
};

export default ClientFilesPage;
